export const sort = (obj: object) => {
  const next: Record<string, unknown> = {};
  Object.keys(obj)
    .sort((a, b) =>
      a.localeCompare(b, undefined, {
        numeric: true,
        sensitivity: 'base',
      }),
    )
    .forEach((key) => {
      next[key] = obj[key as keyof typeof obj];
    });
  return next;
};
